module.exports = __webpack_public_path__ + "img/login_banner_new.bcb27143.png";